import { Directive } from '@angular/core';

@Directive({
    selector: '[wlmGridButtonsFirstSlot]',
    standalone: false
})
export class GridButtonsFirstSlotDirective {}
